import styled, { css } from "styled-components"

const anchorStyles = css`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.firefly};

  &:hover {
    color: ${({ theme }) => theme.colors.firefly};
  }

  &:active {
    opacity: 0.6;
  }
`

const Anchor = styled.a`
  ${anchorStyles}
`

export { Anchor, anchorStyles }
